module.exports = __webpack_public_path__ + "img/mixedcloud.b63bc8c2.png";